/* global history */
import {jQuery as $} from 'mk/jQuery';
import './select2';
import {isMqMobile} from 'mk/common/responsive';

const Utils = $.fn.select2.amd.require('select2/utils');
const Dropdown = $.fn.select2.amd.require('select2/dropdown');
const DropdownSearch = $.fn.select2.amd.require('select2/dropdown/search');
const CloseOnSelect = $.fn.select2.amd.require('select2/dropdown/closeOnSelect');
const AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody');

/**
 * plugin do Select2, ktory dorobi mobilne spravanie pre selectbox
 */
function AttachBodyMobile(decorated, $element, options) {
    decorated.call(this, $element, options);
}

AttachBodyMobile.prototype.position = function(decorated, $dropdown, $container) {
    decorated.call(this, $dropdown, $container);
};

AttachBodyMobile.prototype._showDropdown = function(decorated) {
    if (isMqMobile()) {
        let self = this;

        // schovaj select2 menu ked user stlaci backbutton
        history.pushState({selectIsOpened: true}, null, '#select_open');
        this.$popstateCallback = function(ev) {
            if (ev.originalEvent.state.selectIsOpened) {
                self.trigger('close');
            }
        };
        $(window).bind('popstate', this.$popstateCallback);
        $(document.body).css({'overflow-y': 'hidden'});
        self.$dropdownContainer.addClass('mq-mobile');

        // http://stackoverflow.com/questions/2952782/preventing-an-input-element-from-scrolling-the-screen-on-iphone/7451425#7451425
        $('input.select2-search__field').bind('focusin focus', function(e) {
            e.preventDefault();
        });

        setTimeout(function() {
            self.$dropdownContainer.appendTo(self.$dropdownParent);

            self._positionDropdown();
            self._resizeDropdown();
            self.$search.focus();
        }, 0);
    } else {
        decorated.call(this);
    }
};

AttachBodyMobile.prototype._hideDropdown = function(decorated) {
    if (isMqMobile()) {
        let self = this;
        $(window).bind('popstate', this.$popstateCallback);
        setTimeout(function() {
            $(document.body).css({'overflow-y': ''});
            decorated.call(self);
        }, 500);
    } else {
        decorated.call(this);
    }
};

AttachBodyMobile.prototype._positionDropdown = function(decorated) {
    let isCurrentlyBelow;
    let newDirection;
    let css;

    if (isMqMobile()) {
        isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
        newDirection = isCurrentlyBelow ? null : 'below';

        css = {
            position: 'fixed',
            top: 0,
            left: 0,
        };

        if (newDirection != null) {
            this.$dropdown
                .removeClass('select2-dropdown--below select2-dropdown--above')
                .addClass('select2-dropdown--' + newDirection);
            this.$container
                .removeClass('select2-container--below select2-container--above')
                .addClass('select2-container--' + newDirection);
        }

        this.$dropdownContainer.css(css);
    } else if (this.$container.parent().hasClass('field-wrapper')) {
        // position relative to field-wrapper, so that the menu is correctly
        // placed also if the form is placed inside of a fixed overlay div
        isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
        newDirection = isCurrentlyBelow ? null : 'below';

        let label = this.$container.prevAll('label');
        let container = {
            height: this.$container.outerHeight(false) + (label.length ? label.outerHeight(true) : 0),
        };

        css = {
            top: container.height,
            left: 0,
        };

        if (newDirection != null) {
            this.$dropdown
                .removeClass('select2-dropdown--below select2-dropdown--above')
                .addClass('select2-dropdown--' + newDirection);
            this.$container
                .removeClass('select2-container--below select2-container--above')
                .addClass('select2-container--' + newDirection);
        }

        this.$dropdownContainer.css(css);
    } else {
        // use default positioning logic from select2
        decorated.call(this);
    }
};

AttachBodyMobile.prototype._resizeDropdown = function(decorated) {
    if (isMqMobile()) {
        // do not resize, css scales dropdown to 100%
    } else {
        decorated.call(this);
    }
};

export const MobileDropdownAdapter = Utils.Decorate(
    Utils.Decorate(
        Utils.Decorate(
            Utils.Decorate(Dropdown, DropdownSearch),
            CloseOnSelect
        ),
        AttachBody
    ),
    AttachBodyMobile
);
